import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuthentication } from "@src/components/wrappers/AuthenticationProvider";
import { apiPaths } from "@src/constants";
import { GoogleCalendar } from "@src/api/v1/GoogleCalendar";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";

export const useCalendarQuery = () => {
  const queryClient = useQueryClient();
  const { isLoggedIn } = useAuthentication();

  const { data: calendarData, refetch } = useQuery({
    queryKey: [apiPaths.getGoogleCalendar],
    queryFn: () =>
      new GoogleCalendar(OpenUpHttpClient).getCalendars().catch((error) => {
        if (error?.response?.status === 400) {
          return {
            notRegistered: true,
          };
        }
        throw error;
      }),
    enabled: !!isLoggedIn,
  });

  const { mutateAsync: registerCalendar, isPending: isCalendarSubmitting } =
    useMutation({
      mutationFn: (calendarId: string) =>
        new GoogleCalendar(OpenUpHttpClient).registerCalendar({
          calendarId,
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["psychologists"],
        });
      },
    });

  return {
    refetch,
    calendarData,
    registerCalendar,
    isCalendarSubmitting,
  };
};
